import axios from 'axios'
import Swal from 'sweetalert2'

// Obtener el modo de compilación desde las variables de entorno
const BUILD_MODE = process.env.VUE_APP_BUILD_MODE;

// Función para obtener la URL base del servicio de login según el entorno
function getLoginBaseURL() {
  switch (BUILD_MODE) {
    case "1":
      return 'http://127.0.0.1:30';
    case "2":
      return 'https://authentic.api-preproduccion.cl';
    case "3":
      return 'https://api.authentic.cl';
    default:
      return 'https://api.authentic.cl'; // Por defecto producción
  }
}

// Función para obtener la URL base de los servicios generales según el entorno
function getGeneralBaseURL() {
  switch (BUILD_MODE) {
    case "1":
      return 'http://127.0.0.1:33';
    case "2":
      return 'https://centralgym.api-preproduccion.cl';
    case "3":
      return 'https://api.centralgym.cl';
    default:
      return 'https://api.centralgym.cl'; // Por defecto producción
  }
}

// Determinar si estamos en desarrollo (modo 1 o 2)
export const ToDesa = BUILD_MODE === "1" || BUILD_MODE === "2";

// Función para limpiar la sesión (similar a la que está en main.js)
const clearSession = () => {
  sessionStorage.clear();
  localStorage.clear();
  // Limpiar cookies relacionadas con la sesión
  document.cookie.split(";").forEach(function(c) { 
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
  });
};

// Función común para manejar el token expirado
const handleTokenExpired = () => {
  // Limpiar la sesión
  clearSession();
  
  // Mostrar mensaje de sesión expirada
  Swal.fire({
    title: 'Sesión Expirada',
    html: `
      <div style="text-align: center;">
        <div style="font-size: 48px; color: #dc3545; margin-bottom: 20px;">
          <i class="nc-icon nc-time-alarm"></i>
        </div>
        <p style="margin-bottom: 15px; color: #666;">
          Tu sesión ha expirado por seguridad después de 24 horas de uso.
        </p>
        <p style="font-size: 14px; color: #999;">
          Por favor, inicia sesión nuevamente para continuar.
        </p>
      </div>
    `,
    icon: 'warning',
    confirmButtonText: 'Ir al Login',
    confirmButtonColor: '#6bd098',
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      confirmButton: 'btn btn-success'
    }
  }).then(() => {
    // Redirigir al login usando window.location para evitar dependencias circulares
    window.location.href = '/login';
  });
};

// Función para crear interceptor de respuesta común
const createResponseInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    // En caso de éxito, simplemente retornar la respuesta
    response => response,
    // En caso de error, verificar si es token expirado
    error => {
      // Verificar si hay respuesta del servidor
      if (error.response && error.response.data) {
        const responseData = error.response.data;
        
        // Verificar si es un error 401 con mensaje de token expirado
        // Soporta tanto la estructura antigua (Response.Resultado) como la nueva (result)
        const isOldStructure401 = responseData.Response && 
                                   responseData.Response.Resultado && 
                                   responseData.Response.Resultado.CodigoHTTP === 401 &&
                                   responseData.Response.Resultado.MensajeServicio && 
                                   responseData.Response.Resultado.MensajeServicio.includes('Token expired');
        
        const isNewStructure401 = responseData.result && 
                                   responseData.result.httpCode === 401 &&
                                   responseData.result.message && 
                                   (responseData.result.message.includes('Token expirado') || 
                                    responseData.result.message.includes('Token expired') ||
                                    responseData.result.message.includes('No autorizado'));
        
        if (error.response.status === 401 || isOldStructure401 || isNewStructure401) {
          // Manejar token expirado
          handleTokenExpired();
          
          // Rechazar la promesa para detener el flujo
          return Promise.reject(new Error('Token expirado'));
        }
      }
      
      // Para otros errores, simplemente rechazar la promesa
      return Promise.reject(error);
    }
  );
};

// Instancia para autenticación de usuarios
export const axiosLogin = axios.create({
  baseURL: getLoginBaseURL(),
  timeout: 5000000
});
// Agregar interceptor a axiosLogin
createResponseInterceptor(axiosLogin);

// Instancia para MasterControl APP
export const MasterControlAPP = axios.create({
  baseURL: `${getGeneralBaseURL()}/atlas/mastercontrol`,
  headers: {
    'yebajJVkaZ': ToDesa
  }
});
// Agregar interceptor a MasterControlAPP
createResponseInterceptor(MasterControlAPP);

// Instancia para MasterControl API
export var MasterControlAPI = axios.create({
  baseURL: getGeneralBaseURL(),
  headers: {
    'yebajJVkaZ': ToDesa
  }
});
// Agregar interceptor a MasterControlAPI
createResponseInterceptor(MasterControlAPI);

// Instancia para CentralGym Operations
export var CentralGymOPS_API = axios.create({
  baseURL: `${getGeneralBaseURL()}/dashboard`,
  timeout: 30000, // 30 segundos timeout
  headers: {
    'yebajJVkaZ': ToDesa
  }
});
// Agregar interceptor a CentralGymOPS_API
createResponseInterceptor(CentralGymOPS_API);

// Instancia para CentralGym Operations - Endpoints Públicos (sin interceptor de tokens)
export var CentralGymOPS_API_Public = axios.create({
  baseURL: `${getGeneralBaseURL()}/dashboard`,
  timeout: 30000, // 30 segundos timeout
  headers: {
    'yebajJVkaZ': ToDesa,
    'Content-Type': 'application/json'
  }
});
// NO agregar interceptor a esta instancia - es para endpoints públicos

// Instancia para descarga de plantillas XLSX
export var XLSXTemplateDownload = axios.create({
  baseURL: `${getGeneralBaseURL()}/download/template`,
  headers: {
    'yebajJVkaZ': ToDesa
  }
});
// Agregar interceptor a XLSXTemplateDownload
createResponseInterceptor(XLSXTemplateDownload);

// Instancia para descargas de MasterControl
export var DownLoadsMasterControl = axios.create({
  baseURL: `${getGeneralBaseURL()}/atlas/download`,
  headers: {
    'yebajJVkaZ': ToDesa
  }
}); 
// Agregar interceptor a DownLoadsMasterControl
createResponseInterceptor(DownLoadsMasterControl);

// Nueva instancia específica para el centro de actualizaciones
export var UpdatesCenter = axios.create({
  baseURL: 'https://updates.centralgym.app',
  timeout: 30000
});
// Agregar interceptor a UpdatesCenter
createResponseInterceptor(UpdatesCenter);

export var Operations = {
  Login: "user/auth/login",
  UpdatePassword: "authuser",
  UpdatePasswordOP: "/user/update/password",
  GetConfig: "/v1/get/config"
};

export var Env = Number.parseInt(process.env.VUE_APP_BUILD_MODE);
